import { INTERNAL_INTL_LOCALE } from '../utils/publicLocalePath'

/**
 * Controlla la visibilità del pulsante ricerca nell'header.
 * Sul sito vetrina internazionale (/en, locale interno en-wx) la ricerca è nascosta,
 * salvo override esplicito via query `?showSearch=true`.
 */
export const useShowHeaderSearch = () => {
  const route = useRoute()
  const appConfig = useAppConfig()

  const isIntlShowcaseSite = computed(
    () =>
      (appConfig.currentLanguageCountry ?? '').toLowerCase() ===
      INTERNAL_INTL_LOCALE
  )

  const showHeaderSearch = computed(
    () => route.query.showSearch === 'true' || !isIntlShowcaseSite.value
  )

  return {
    isIntlShowcaseSite,
    showHeaderSearch,
  }
}
